import { Reducer } from 'redux';
import { AnonymousViewActionTypes, AnonymousViewState } from './types';

export const initialState: AnonymousViewState = {
  anonymousEnquiry: undefined,
  isLoadingData: false,
  anonymousEnquiryError: undefined,
  anonymousEnquiryAutoRenewProperties: undefined,
  isLoadingAutoRenewPropertiesData: false,
  state: 'loading'
};

const reducer: Reducer<AnonymousViewState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_START: {
      return {
        ...state,
        isLoadingData: true,
        anonymousEnquiry: undefined,
        anonymousEnquiryError: undefined
      };
    }
    case AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_SUCCESS: {
      return {
        ...state,
        isLoadingData: false,
        anonymousEnquiry: action.payload,
        anonymousEnquiryError: undefined
      };
    }
    case AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_FAILURE: {
      return {
        ...state,
        isLoadingData: false,
        anonymousEnquiry: undefined,
        anonymousEnquiryError: action.payload
      };
    }
    case AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_START: {
      return {
        ...state,
        isLoadingAutoRenewPropertiesData: true,
        anonymousEnquiryAutoRenewProperties: undefined
      };
    }
    case AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_SUCCESS: {
      return {
        ...state,
        isLoadingAutoRenewPropertiesData: false,
        anonymousEnquiryAutoRenewProperties: action.payload
      };
    }
    case AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_FAILURE: {
      return {
        ...state,
        isLoadingAutoRenewPropertiesData: false,
        anonymousEnquiryAutoRenewProperties: undefined
      };
    }
    case AnonymousViewActionTypes.GET_ANONYMOUS_CREDENTIAL_START: {
      return {
        ...state,
        state: 'loading'
      };
    }
    case AnonymousViewActionTypes.GET_ANONYMOUS_CREDENTIAL_FAILURE: {
      return {
        ...state,
        state: 'fail',
        error: action.payload
      };
    }
    case AnonymousViewActionTypes.GET_ANONYMOUS_CREDENTIAL_SUCCESS: {
      return {
        ...state,
        state: 'success',
        credentials: action.payload
      };
    }
    default:
      return state;
  }
};

export default reducer;
